import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { useIsLoading, useLoadingMessage } from '@/store';

/**
 * Global loading overlay component
 * Replaces Angular's LoaderService + CDK Overlay implementation
 */
export const GlobalLoader: React.FC = () => {
  const isLoading = useIsLoading();
  const loadingMessage = useLoadingMessage();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        flexDirection: 'column',
        gap: 2,
      }}
      open={isLoading}
    >
      <CircularProgress color="inherit" size={48} />
      {loadingMessage && (
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body1">{loadingMessage}</Typography>
        </Box>
      )}
    </Backdrop>
  );
};

export default GlobalLoader;
